<template>
  <div class="bg-wrap" style="position:relative;">
    <div class="main-cont-wrap">
      <div class="settle-box">
        <div class="title g-mb20">入驻营客通</div>
        <div class="pdl28 pdr28">
          <div class="g-mb20" v-if="isRegister">
            <div class="input-box g-mb20">
              <el-input placeholder="请输入手机号码" auto-complete="new-password"
                v-model="registerData.contactPhone"></el-input>
            </div>
            <div class="input-box flex-wrap g-mb20 pdr15">
              <el-input placeholder="请输入验证码" auto-complete="new-password" v-model="registerData.valideCode"></el-input>
              <el-button type="text" @click="codeFun(59)">{{ codeOrCountdown }}</el-button>
            </div>
          </div>
          <div class="btn-box g-mb20">
            <el-button v-if="isRegister" style="width: 100%;height: 54px;background: #3B6FFA;border-radius: 10px;"
              type="primary" @click="registerSubmit">
              {{ viewProgress ? '立即查看' : '立即入驻' }}
            </el-button>
            <!-- <el-button v-else style="width: 100%;height: 54px;background: #3B6FFA;border-radius: 10px;" type="primary"
              :loading="logining" @click="loginSubmitCheck">
              {{ loginStr }}
            </el-button> -->
          </div>
          <!-- <div v-if="isRegister">
            <div class="flex-wrap flex-sb">
              <div v-if="viewProgress">
                <span class="">还没有入驻？</span>
                <el-button type="text" @click="viewProgress = false">立即入驻</el-button>
              </div>
              <div v-else>
                <span class="">已提交入驻信息？</span>
                <el-button type="text" @click="viewProgress = true">查看进度</el-button>
              </div>
              <div>
                <span class="">已有账号？</span>
                <el-button type="text" @click="logoNow">立即登录</el-button>
              </div>
            </div>
            <div>
              <a style="color:#409EFF;" href="http://admin.ksaxshop.com/SupplierRegister/EntryProcess"
                target="_blank">入驻流程</a>
              <a style="color:#409EFF;" class="mgl20" href="http://admin.ksaxshop.com/SupplierRegister/EntryIntroduce"
                target="_blank">入驻介绍</a>
            </div>
          </div>
          <div class="" v-else>
            <div class="tool-box">
              <div>
                <el-checkbox v-model="checked" class="remember">记住密码</el-checkbox>
              </div>
              <div class="register" @click="registerFun">申请入驻</div>
            </div>
            <div class="">
              <el-checkbox v-model="isAgree"></el-checkbox>
              <a style="text-decoration: none;
            color: rgb(0, 0, 0);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #191919;
            font-size: 14px;
            margin-left: 8px;text-decoration: none; color: #000" href="#" @click="agree">《同意集市入驻服务协议》</a>
            </div>
          </div> -->
        </div>
        <div class="msg-box">
          <div id="messageBox" class="text"></div>
        </div>
      </div>
    </div>
    <el-dialog class="scrolling" title="集市供应商入驻协议" :visible.sync="isAgreeVisible" width="70%">
      <p style="line-height: 25px;height: 350px;overflow-y:scroll">
        <strong>集市入驻服务协议</strong> <br />
        欢迎您与集市平台经营者上海赢可通信息科技有限公司（“集市平台经营者”或“营客通”）共同签署本《集市入驻服务协议》（下称“本协议”）并使用集市平台服务（定义见下文）。 <br /><br />

        您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可向集市平台客服咨询。<br /><br />

        当您按照注册页面提示填写信息、阅读并同意本协议且完成全部入驻注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与集市平台经营者达成一致，成为集市平台“商户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止入驻注册程序。<br />
        <strong>一、定义</strong> <br /><br />
        集市平台：指营客通App客户端-集市板块。 <br />
        集市平台服务：集市平台经营者基于互联网，以包含营客通App客户端-集市板块、附近的店小程序等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务，包括但不限于店铺管理、商品发布、信息交流以及其他等有偿或无偿的服务。
        <br />
        集市平台规则：包括在所有集市平台中已经或将来可能发布的全部规范性文件，包括但不限于集市平台经营者于集市平台发布的各类规则、实施细则、产品流程说明、公告等。 <br />
        商户：指集市平台有效注册商户。 <br />
        买家：指在集市电商平台上浏览或购买商品的商户。 <br />
        卖家：指在集市电商平台上发布或出售商品的商户，也称“供应商”。 <br />


        <strong> 二、协议范围 </strong><br /><br />
        <strong>2.1 签约主体</strong><br />
        本协议由您与上海赢可通信息科技有限公司-即集市平台经营者共同缔结，本协议对您与上海赢可通信息科技有限公司均具有合同效力。<br />
        为免疑义，本协议项下，集市平台经营者可能根据集市平台的业务调整而发生变更，变更后的集市平台经营者与您共同履行本协议并向您提供服务，集市平台经营者的变更不会影响您本协议项下的权益。集市平台经营者还有可能因为提供新的集市平台服务而新增，如您使用新增的集市平台服务的，视为您同意新增的集市平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。<br />
        <strong>2.2补充协议</strong> <br />
        由于互联网高速发展，您与集市平台经营者签署的本协议列明的条款并不能完整罗列并覆盖您与集市平台经营者的所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，集市平台隐私权政策、法律声明、集市平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用集市平台服务，视为您同意上述补充协议。<br />

        <strong>三、供应商账户注册与使用</strong><br /><br />

        <strong>3.1 商户资格</strong><br />
        您确认，在您开始注册程序使用集市平台服务前，您应当持续地满足以下条件：<br />
        (1) 您已依照中华人民共和国法律注册并领取合法有效的营业执照及取得其他经营许可；<br />
        (2) 您所经营的商品来源合法，资质齐全；<br />
        (3) 您提交的任何信息均真实、合法、有效，所使用的图片、文字等不侵犯任何第三方合法权益；<br />
        (4) 营客通依据国家法律法规、政策或其他规范性文件规定要求您具备的其他条件。<br />
        (5) 您已取得所销售的产品，在指定销售地的合法销售权利。<br /><br />
        <strong>3.2 证明文件</strong><br />
        您应当依据集市平台规则以及相应的入驻注册流程，在线签订平台公示的入驻协议，须向平台提交各项必须的资质、证照、证明或其他相关文件（以下统称“证明文件”），包括但不限于三证合一（营业执照、税务登记证、组织机构代码）、开户行证明、授权委托书、商标注册证、质检报告、法定代表人身份证复印件、与家电厂商签订的准许代理售卖协议等，且须向平台提交与原件核对一致并加盖公章的纸质复印件（根据实际业务提供相应资质）。<br />
        集市平台经营者会对您提供的如上真实信息进行核验、登记，并定期核验更新，因此您应当保证上述证明文件发生任何变更或更新时立即通知集市平台经营者，提交更新后的文件进行相应认证。<br />
        您提交虚假、过期文件或未及时通知并提交更新文件等情形的，应独立承担全部法律责任。您提交的信息不符合集市平台公示要求的，集市平台经营者会一次性通知您补齐相关资料，若您拒绝，集市平台经营者有权调整您的相关权限，直至终止本协议，若因此造成集市平台经营者及任何第三方损失，应承担全部责任与赔偿。
        <strong>3.2入驻保证金（补充）</strong><br /><br />
        3.2.1 0元开店<br />
        目前集市扶持新入驻商户，对供应商在平台新入驻阶段设置保护期：<br />
        1.试运营阶段不需要支付保证金。<br />
        2.结算周期为确认收货3个工作日内，通常是每周二、每周五根据真实物流签收进程结算。<br />
        3.试运营期为90个自然日。<br /><br />
        3.2.2 试运营达标补缴保证金<br />
        试运营期间，若商家店铺满足以下任一条件则试运营结束，应进入正式运营期，须在15个自然日内缴纳，或从货款中冻结足额保证金：<br />
        1.试运营满90个自然日；<br />
        2.店铺累计销售额≥100万元；<br />
        3.平台介入投诉单≥1单；<br />
        4.增开非试运营的类目，如综合经营（同时小家电开大家电）。<br />
        入驻保证金标准如下：<br />
        <span class="table2">
          <table>
            <tr>
              <th>类目</th>
              <th>试运营期间剔除退款的店铺成交金额(元)</th>
            </tr>
            <tr>
              <td rowspan="3">综合</td>
              <td> N＜100,000 </td>
            </tr>
            <tr>
              <td>100,000≤N≤1,000,000 </td>
            </tr>
            <tr>
              <td>N＞1,000,000 </td>
            </tr>
          </table>
        </span>
        3.2.3 试运营结束管控<br />
        试运营期结束后，若商家未及时足额缴纳或货款不足以冻结足额保证金，将视采取下列一项或多项管控措施：<br />
        （一）全店商品下架；<br />
        （二）禁止上架待售商品；<br />
        （三）限制创建商品；<br />
        （四）屏蔽店铺。<br /><br />
        3.2.4 终止合作机制<br />
        第一条 自然终止：店铺服务期届满，商家未完成续签的；<br />
        第二条 被动终止：店铺因违规行为被营客通清退。<br />
        第三条 提前终止：未到店铺服务结束日期，主动退出并提前关店的，终止协议操作步骤请见下文；<br />
        第四条 保证金<br />
        第五条 操作流程<br />
        （一）发起申请<br />
        服务协议终止且服务协议所约定的特定店铺所有订单终止、所有争议及索赔已处理完毕、已完成交易的商品质保期届满后，商家向客服发起保证金退还申请，在不出现“未支付的收付费单”等异常情况提醒的前提下，保证金将在在线申请退保证金完成（包括店铺销售品类质保期已满，结算完成等条件）后，退还到商家后台维护且验证通过的银行账户中<br />
        1．按合同约定，提前终止合作的商家不退还该店铺未到期部分对应的平台使用费。请仔细考虑后再申请退店。<br />
        2．根据《电子商务法》要求，电商平台第三方商家在退出平台前，需要提前30天面向消费者说明关店事宜。招商人员审核您的退店申请后，即进入公示期中，请您耐心等候。<br />
        3．公示期内所售出的商品，会正常计入商家关店后的保证金退款质保周期。为了能够尽快完成保证金退款流程，建议您在退店审核通过后及时对商品进行下架处理。<br />
        本次申请完成后，您的店铺关闭、商品全部下架且自关店同主体6个月内不允许再次入驻，请慎重考虑！<br />
        （二）等待审核<br />
        招商人员将在7个工作日内审核您的退出申请，审核期间如有任何问题，我们会随时联系系统中的店铺负责人，请确保信息正确。审核通过后会短信通知店铺负责人。在审核通过之前商家可随时取消申请。<br />
        （三）退出完成<br />
        审核通过，店铺进入公示期，公示期根据店铺实际情况为3-6个月不等，公示期结束店铺自动关闭，期间不可取消退店申请。店铺关闭后会短信通知店铺负责人。<br />
        商家退出营客通集市平台时，店铺保证金会在退店后退还给商家，一般是3-4个工作日到账。<br /><br />

        <strong>3.3账户说明</strong><br />
        3.3.1您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，可获得集市平台账户并成为集市平台商户。<br />
        3.3.2您有权使用您设置或确认的集市会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录集市平台。<br />
        3.3.3由于商户账户关联商户信用信息，仅当有法律明文规定、司法裁定或经集市平台经营者同意，并符合集市平台规则规定的商户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切责任均由您承担。<br /><br />

        <strong>3.4 注册信息管理</strong><br />
        3.4.1 真实合法<br />
        使用集市平台服务时，您应当按集市平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便集市平台经营者或下单客户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。否则，您将自己承担由此产生的所有责任和纠纷。<br />
        3.4.2 更新维护<br />
        如集市平台经营者按您最后一次提供的信息与您联系未果、或您未按集市平台经营者的要求及时提供信息、您提供的信息存在不实的，您将承担因此对您自身、他人及集市造成的全部损失与不利后果。<br /><br />

        <strong>3.5 账户安全规范</strong><br />
        您的账户为您自行设置并由您保管，集市平台经营者任何时候均不会主动要求您提供您的账户。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开集市平台。<br />
        账户因您主动泄露或遭受他人攻击、诈骗等行为导致的损失、纠纷及后果，营客通经营者并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。<br />
        除集市平台经营者存在明显过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。<br />
        如发现任何未经授权使用您账户登录集市平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知集市平台经营者。您理解集市平台经营者对您的任何请求采取行动均需要合理时间，集市平台经营者不承担任何责任。<br /><br />

        <strong>3.6 账户转让</strong><br />
        由于您的账户关联商户信用信息，仅当有法律明文规定、司法裁定或经集市平台经营者同意，并符合集市平台规则规定的账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则集市平台经营者有权追究您的违约责任，且由此产生的相应责任均由您承担。<br /><br />


        <strong>四、集市平台服务及规范</strong><br /><br />

        您有权在集市平台上享受店铺管理、商品及/或服务的销售与推广、商品及/或服务的购买与评价等服务。集市提供的服务内容众多，具体您可登录集市平台浏览。<br /><br />

        <strong>4.1 店铺管理</strong><br />
        通过在集市平台提供的集市模块下创建店铺，您可发布商品及/或服务信息并与其他商户达成交易。基于管理需要，您理解并认可，同一商户在集市平台仅能开设一家店铺，集市可关闭您同时开设的其他店铺。<br />
        由于店铺与账户的不可分性，店铺转让实质为店铺经营者账户的转让，店铺转让的相关要求与限制请适用本协议第3.6条账户转让条款。<br />
        如您通过下架全部产品短暂关停您的店铺，您仍应当对您店铺关停前已达成的交易继续承担发货、纠纷及投诉处理等交易保障责任。<br /><br />

        <strong>4.2商品及/或服务的销售与推广</strong><br /><br />
        4.2.1通过集市平台经营者提供的服务，您有权通过文字、图片、视频、音频等形式在集市平台上发布商品及/或服务信息，内容包括品名、规格、等级、计价单位、产地、价格等，以招揽和物色交易对象、达成交易。<br />
        4.2.2您应当确保您对您在集市平台上发布的商品及/或服务享有相应的权利，您不得在集市平台上销售以下商品及/或提供以下服务：<br />
        （一）国家禁止或限制的；<br />
        （二）侵犯他人知识产权或其它合法权益的；<br />
        （三）集市平台规则或各平台与您单独签署的协议中已明确说明不适合在集市平台上销售及/或提供的。<br />
        4.2.3您应当遵守诚实信用原则，有义务确保在集市平台销售的商品按照国家标准、行业而标准以及平台发布的各类商品要求进行质量控制（包括但不限于商品法律法规符合性、商品安全性、商品功能材质与描述符合性、商品标识标示、商品外观，商品包装等），并依照国家法律法规提供售后三包服务。集市平台有权根据市场反馈自行或委托第三方质检机构进行不定期商品抽检（检测项目包括但不限于销售商品的性能、质量、材料成分等；抽检方式包括但不限于匿名购买、对于买家订单信息及页面信息进行检查等）或要求您对集市平台指定商品提供进货凭证，出厂检验报告等相关商品及批次的质量合格证明文件。集市平台经营者有权依据抽检结果反映的问题以及问题的严重程序对您提出相应的限期整改要求，违规处理以及追究违约责任。<br />
        4.2.4您应当维护集市平台市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰集市平台上进行的任何交易、活动，不得以任何不正当方式提升或试图提升自身的信用度，不得以任何方式干扰或试图干扰集市平台的正常运作。<br />
        4.2.5您有权自行决定商品及/或服务的促销及推广方式，集市平台亦为您提供了形式丰富的促销推广工具。您的促销推广行为应当符合国家相关法律法规及集市平台的要求。<br /><br />
        4.3店铺评价<br />
        您在集市平台提供的评价系统中收到的与您达成交易的买家的评价，不得随意自行删除。<br /><br />
        4.4平台服务费、店铺款项及税收<br />
        4.4.1您应同意并授权集市平台经营者通过与银联或合作银行签订的监管分账形式，由银行独立监管账户代您收取买家支付的货款。依据您与买家确认的结算流程，自买家确认收货后的3个工作日后，银行监管账户会将货款将结算至您的账户。集市平台经营者向您收取平台服务费用，冰、空、彩、洗四大品类按总价款1.5%收取，其他品类按总价款5%-10%收取，平台服务费用将在货款结算中予以直接扣除。<br />
        4.4.2依法纳税是每一个公民、企业应尽的义务，您应对销售额/营业额超过法定免征额部分及时、足额地向税务主管机关申报纳税，并且有义务按照买家实际支付的金额，按其要求开具发票。<br />


        <br /><strong>五、商户信息的保护及授权</strong><br /><br />

        <strong>5.1个人信息的保护</strong><br />
        集市平台经营者非常重视商户个人信息（即能够独立或与其他信息结合后识别商户身份的信息）的保护，在您使用集市提供的服务时，您同意集市平台经营者按照在集市平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。集市平台经营者希望通过隐私权政策向您清楚地介绍集市平台经营者对您个人信息的处理方式，因此集市平台经营者建议您完整地阅读隐私权政策（点击此处或点击集市平台首页底部链接），以帮助您更好地保护您的隐私权。<br /><br />

        <strong>5.2非个人信息的保证与授权</strong><br />
        您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，集市平台经营者可对您发布的信息依法或依本协议经通知后可进行删除或屏蔽。<br />
        您应当确保您所发布的信息不包含以下内容：<br />
        （一）违反国家法律法规禁止性规定的；<br />
        （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；<br />
        （三）欺诈、虚假、不准确或存在误导性的；<br />
        （四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；<br />
        （五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；<br />
        （六）存在可能破坏、篡改、删除、影响集市平台任何系统正常运行或未经授权秘密获取集市平台及其他商户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；<br />
        （七）其他违背社会公共利益或公共道德或依据相关集市平台协议、规则的规定不适合在集市平台上发布的。<br />

        <br /><strong>六、店铺卖家的违约处罚</strong><br /><br />
        <strong>6.1发生如下情形之一的，视为您违约：</strong><br />
        （一）使用集市平台服务时违反有关法律法规规定的；<br />
        （二）销售货品与描述不符的，包括但不限于品牌、型号、产品功能、产品参数。<br />
        （三）违反本协议或本协议补充协议约定的。<br />
        为适应电子商务发展和满足海量商户对高效优质服务的需求，您理解并同意，集市平台经营者可在集市平台规则中约定违约认定的程序和标准。如：集市平台经营者可依据您的商户数据与海量商户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。<br />

        <strong>6.2 违约处理措施（补充）</strong><br />
        6.2.1您在集市平台上发布的信息构成违约的，集市平台经营者可根据相应规则立即对相应信息经通知后进行删除、屏蔽处理或对您的商品进行下架、监管。<br />
        6.2.2您在集市平台上实施的行为，或虽未在集市平台上实施但对集市平台及其商户产生影响的行为构成违约的，集市平台经营者可依据相应规则中止向您提供部分或全部服务、从保证金账户或货款中划扣违约金等处理措施。<br />
        6.2.3若您有销售假冒伪劣商品等侵犯知识产权行为、涉嫌非法信用卡套现等违法活动，并有可能涉嫌刑事犯罪的，集市平台经营者有权向相应机关（包括但不限于行政监管机关、公安机关、司法机关以及其他有权机关）提供您一切资料与信息，并配合相应机关的调查取证和侦查工作。<br />
        6.2.4 发货违规（补充）<br />
        第一条 违规情形包括但不限于：虚假发货、延迟发货、未发货订单积压、缺货无货、拒绝发货、少件、错件、未按照要求使用发货方式等。<br />
        第二条 处理措施：营客通有权视违规程度对店铺执行扣除违约金、下架违规商品和限售等处理措施。营客通有权依据协议等，根据商家违规程度，对商家采取如下处理：<br />
        <span class="table1">
          <table>
            <tr>
              <th>违规情形</th>
              <th>具体处理措施</th>
            </tr>
            <tr>
              <td style="width: 200px;">虚假发货</td>
              <td> 每单扣除订单金额2%，下限20元上限100元，对应商品下架处理。 </td>
            </tr>
            <tr>
              <td>延迟发货 </td>
              <td>
                商家在商品订单承诺发货时效内仍未完成揽件的订单（>承诺揽收时效），营客通有权直接从商家钱包账户（包括钱包、货款、保证金等）中扣除对应的客户赔付金1%（下限20元上限100元），并将同等金额以盟友豆/平台补偿券的形式发放给延迟发货订单所对应的消费者。
              </td>
            </tr>
            <tr>
              <td>延迟发货并有客诉</td>
              <td>商家实际发货时效比承诺揽收时效晚72小时并引起客户投诉 平台介入处理
                1. 平台扣除供应商该订单金额的1.5%（下限20元上限100元）作为未能履行订单的罚款
                2.根据客户诉求①继续发货（换采）给用户固定金额的优惠券/返豆 ②取消订单并补偿给用户固定金额的优惠券/返豆 </td>
            </tr>
            <tr>
              <td>未发货订单积压</td>
              <td>营客通有权根据未发货订单积压情况对全店商品进行限售。</td>
            </tr>
            <tr>
              <td>缺货无货/拒绝发货</td>
              <td>严重超期未发货时采取按订单金额的1%扣除违约金（下限20元上限100元），商品下架处理。</td>
            </tr>
            <tr>
              <td>少件、错件</td>
              <td>严重少错件时采取按订单金额的2%扣除违约金（下限20元上限100元），商品下架处理。</td>
            </tr>
          </table>
        </span>
        <!--        违规情形	具体处理措施<br />-->
        <!--        虚假发货	每单扣除订单金额2%，下限20元上限100元，对应商品下架处理。<br />-->
        <!--        延迟发货	商家在商品订单承诺发货时效内仍未完成揽件的订单（>承诺揽收时效），营客通有权直接从商家钱包账户（包括钱包、货款、保证金等）中扣除对应的客户赔付金1%（下限20元上限100元），并将同等金额以盟友豆/平台补偿券的形式发放给延迟发货订单所对应的消费者。<br />-->
        <!--        延迟发货并有客诉	商家实际发货时效比承诺揽收时效晚72小时并引起客户投诉 平台介入处理<br />-->
        <!--        1. 平台扣除供应商该订单金额的1.5%（下限20元上限100元）作为未能履行订单的罚款<br />-->
        <!--        2.根据客户诉求①继续发货（换采）给用户固定金额的优惠券/返豆 ②取消订单并补偿给用户固定金额的优惠券/返豆<br />-->
        <!--        未发货订单积压	营客通有权根据未发货订单积压情况对全店商品进行限售。<br />-->
        <!--        缺货无货/拒绝发货	严重超期未发货时采取按订单金额的1%扣除违约金（下限20元上限100元），商品下架处理。<br />-->
        <!--        少件、错件	严重少错件时采取按订单金额的2%扣除违约金（下限20元上限100元），商品下架处理。<br />-->
        一、虚假发货：<br />
        营客通认定虚假发货的情形包括但不限于：<br />
        商家上传物流运单号的地址与订单的实际收货地址不同；<br />
        商家上传的物流运单号已经被其他订单使用；<br />
        上传的物流运单号对应的收到的货物与实际购买订单货物不符【（拍A发B：特指收到的货物与实际购买的完全不一致，不包含品牌问题、商品宣传问题）、赠品、空包】；<br />
        商家上传的物流单号与实际发货的物流单号不符；<br />
        针对以上虚假发货的情况一经核实予以处罚，每单扣除订单金额2%，下限20上限100元，对应商品下架处理。<br />
        二、延迟发货：<br />
        是指商家设置商品的承诺发货时效后，未按时效完成揽件的情形，揽件是指商家在承诺发货时效内，上传订单对应的物流单号至营客通平台并有物流公司揽件信息。<br />
        三、未发货订单积压<br />
        商家在经营过程中，所售商品量超出自身发货能力，造成未发货订单积压时，营客通有权视积压程度对全店所有商品进行限售。<br />
        轻度积压：按商家承诺应揽件日期（Promise），日订单量>10单时若后续超承诺24小时未揽件订单占比≥10%，或近30天累计超承诺24小时未揽件订单量>20单，则管控触发，对全店所有商品全区域限售24小时。<br />
        重度积压：按商家承诺应揽件日期（Promise），日订单量>30单时若后续超承诺72小时未揽件订单占比≥20%，或近30天累计超承诺72小时未揽件订单量>50单，则触发管控，对全店所有商品全区域限售72小时。<br />
        四、缺货无货/拒绝发货<br />
        营客通认定缺货无货/拒绝发货的情形包括但不限于：<br />
        1.商家订单超过承诺应揽件日期7天仍未揽件的；<br />
        2.商家承认缺货无货/要求加价发货的；<br />
        3.消费者付款成功后，如双方无其它约定，商家拒绝按照消费者下单的价格交易或履行发货义务的（简称“拒绝发货”）。<br />
        针对缺货无货/拒绝发货场景，如引起消费者投诉或违规程度严重的，营客通有权采取对应商品下架处理；此外，缺货无货/拒绝发货包括商品属性、规格、价格等信息标错所导致未能履行承诺发货的，并且包括商家未在规定时间内处理完成或因处理不当导致大量客诉的订单。<br />
        针对严重超期未发货订单，在订单超过商家承诺应揽件日期（Promise）7天仍未揽件时，营客通将按照订单实际金额1%进行处罚，最低20元，最高100元。此外，违规商家仍需要按相关要求积极处理消费者投诉问题。（如果订单已经产生过缺货无货/拒绝发货情形赔付，商家需与消费者联系协商解决）<br />
        五、少件<br />
        商家未按照订单明细和网页商品描述或者商品实际重量/配件等打包发送订单商品，消费者投诉收到的订单商品存在少配件、少赠品，少商品的（简称“少件”）。如引起消费者投诉或违规程度严重的，营客通有权按照订单实际金额2%扣划违约金，最低20元，最高100元，并下架对应商品。<br />
        六、错件<br />
        商家在非主观恶意的情况下，给消费者发送的商品与达成交易时的订单商品不一致，特指同一商品物理属性问题，如：尺码、尺寸或颜色等。如引起消费者投诉或违规程度严重的，营客通有权按照订单实际金额2%扣划违约金，最低20元，最高100元，并下架对应商品。<br />

        6.2.5 不合规交易（补充）<br />
        用户在平台的交易行为受到保护，不允许供应商和用户在集市店铺平台外发生交易，商家将用户在营客通平台提交的订单引导至商家自有平台或其他合作平台交易的行为，包括商家有意向引导用户至其自有平台或其他合作平台交易但未成功交易的行为，简称为飞单行为。<br />
        飞单常见违规场景<br />
        【常见违规场景1】<br />
        用户咨询期间/用户下单支付后，商家以各种不合理理由拒绝对在平台上架的商品/服务进行发货，引导用户按照订单金额或低于订单金额进行其他方式支付。<br />
        【常见违规场景2】<br />
        用户咨询期间/用户下单支付后，商家以各种不合理理由拒绝对在平台上架的商品/服务进行发货，引导用户退货去第三方平台直接下单购买。<br />
        【常见违规场景3】<br />
        用户咨询期间/用户下单支付后，商家引导用户使用商家其他优惠方式替代平台商品/服务支付消费款项。<br />
        【常见违规场景4】<br />
        用户咨询期间/用户下单支付后，商家提供其他更为优惠的方案引导用户使用非平台方式支付消费款项。<br />
        <!--        违规情形	具体处理措施<br />-->
        <!--        轻微（无实际产生飞单行为，有诱导行为）	警告并罚款200，限制创建商品3日，全店所有商品全区域限售24小时<br />-->
        <!--        一般（产生1-2次飞单行为）	扣取20%飞单订单金额，上限1000元，全店所有商品全区域限售72小时<br />-->
        <!--        极其严重（产生3次及以上飞单行为）	扣除保证金并执行店铺清退<br />-->
        <span class="table3">
          <table>
            <tr>
              <th>轻微（无实际产生飞单行为，有诱导行为）</th>
              <th>具体处理措施</th>
            </tr>
            <tr>
              <td style="width: 200px;">轻微（无实际产生飞单行为，有诱导行为）</td>
              <td> 警告并罚款200，限制创建商品3日，全店所有商品全区域限售24小时 </td>
            </tr>
            <tr>
              <td>一般（产生1-2次飞单行为） </td>
              <td>扣取20%飞单订单金额，上限1000元，全店所有商品全区域限售72小时 </td>
            </tr>
            <tr>
              <td>极其严重（产生3次及以上飞单行为）</td>
              <td>扣除保证金并执行店铺清退</td>
            </tr>
          </table>
        </span>

        <strong>6.3赔偿责任</strong><br />
        如您的行为使集市平台经营者或买家遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿集市平台经营者或买家的上述全部损失。如您的行为使集市平台经营者遭受第三人主张权利，集市平台经营者可在对第三人承担金钱给付等义务后就全部损失向您追偿。在集市平台经营者接到买家投诉、法律诉讼等可能遭受损失时，集市平台经营者有权扣押、或扣除您的货款。<br />
        对于所销售的商品，若违反6.1（二）销售货品与描述不符的，卖家对集市平台经营者和买家承担无限期的赔偿责任。<br />
        <strong>6.4公示</strong><br />
        集市平台经营者可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在集市平台上予以公示。<br />
        <strong>6.5特别约定</strong><br />
        6.5.1如您向集市平台经营者的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，集市平台经营者可立即终止与您的所有合作并向您收取违约金或赔偿金，该等金额以集市平台经营者因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。<br />
        6.5.2如您因违约导致集市平台经营者终止本协议时，出于维护平台秩序以及保护其他商户合法权益的目的，集市平台经营者可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以协议约定的方式通知您。<br />
        6.5.3卖家自行监管自己商品的销售地、商品的安装地。如果因发生串货行为，而受到商户上游厂家责罚，与集市平台经营者无关。<br />
        6.5.4卖家自行控制销售价格，若因与厂家签订过价格约定，涉及到厂家判定卖家乱价，造成的任何厂家对卖家的惩罚，由卖家自行承担。<br />

        <br /><strong>七、责任限制</strong><br /><br />

        <strong>7.1集市平台经营者依照法律规定履行基础保障义务，但对于下述不可抗力或其他第三人因素原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，集市平台经营者并不承担相应的违约责任：</strong><br />
        （一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br />
        （二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；<br />
        （三）在集市平台经营者已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。<br />

        <strong>7.2集市平台经营者仅向您提供本协议约定之服务，您了解集市平台上的信息系商户自行发布，且可能存在风险和瑕疵。同时，鉴于集市平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，集市平台作为网络交易平台无法逐一审查产品及/或服务的信息，无法逐一审查交易所涉及的产品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断，如发现存在危害信息和行为，请您及时同集市平台经营者进行联系和投诉，集市平台将对有害信息和行为进行处理。</strong><br />

        <br /><strong>八、协议的变更</strong><br /><br />

        集市平台经营者可根据国家法律法规变化及维护交易秩序需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第八条约定的方式通知您。<br />
        如您不同意变更事项，您有权于变更事项确定的生效日前联系集市平台经营者反馈意见。如反馈意见得以采纳，集市平台经营者将酌情调整变更事项。<br />
        如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用集市平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用集市平台服务，则视为您同意已生效的变更事项。<br />

        <br /> <strong>九、通知</strong><br /><br />

        <strong>9.1您在注册成为集市平台用户，并接受集市平台服务时，您应该向集市平台经营者提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被有效联系的状态。</strong><br />

        <strong>9.2 您同意集市平台经营者以以下合理的方式向您送达各类通知：</strong><br />
        （一）公示的文案；<br />
        （二）站内信、客户端推送的消息；<br />
        （三）根据您预留于集市平台的联系方式发出的电子邮件、短信、函件等。<br />
        集市平台经营者将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。<br />

        <strong>9.3 通知的送达</strong><br />
        9.3.1集市平台经营者通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在集市平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账户发送站内信信息、系统消息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。<br />
        9.3.2对于在集市平台经营者上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在集市平台注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。<br />

        您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。<br />
        您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
        您应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。<br />


        <br /><strong>十、协议的终止</strong><br /><br />
        <strong>10.1 终止的情形</strong> <br />
        10.1.1您有权通过以下任一方式终止本协议：<br />
        （一）在满足集市平台公示的账户注销条件时您通过集市平台自助服务注销您的账户的；<br />
        （二）变更事项生效前您停止使用并书面明示不愿接受变更事项的；<br />
        （三）您明示不愿继续使用集市平台服务，且符合集市平台终止条件的。<br />
        10.1.2出现以下情况时，集市平台经营者可以本协议第九条所列的方式通知您终止本协议：<br />
        （一）您违反本协议约定，集市平台经营者依据违约条款终止本协议的；<br />
        （二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，集市平台经营者依据集市平台规则对您的账户予以查封的；<br />
        （三）除上述情形外，因您多次违反集市平台规则相关规定且情节严重，集市平台经营者依据集市平台规则对您的账户予以查封的；<br />
        （四）其它应当终止服务的情况。<br />
        <strong>10.2 协议终止后的处理</strong> <br />
        10.2.1本协议终止后，除法律有明确规定外，集市平台经营者无义务向您或您指定的第三方披露您账户中的任何信息。<br />
        10.2.2本协议终止后，集市平台经营者仍享有下列权利：<br />
        （一）继续保存您留存于集市平台的本协议第五条所列的各类信息；<br />
        （二）对于您过往的违约行为，集市仍可依据本协议向您追究违约责任。<br />
        10.2.3本协议终止后，对于您在本协议存续期间产生的交易订单，集市可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。<br /><br />


        <strong>十一、法律适用、管辖与其他</strong><br /><br />

        11.1本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。<br />
        11.2您与集市平台经营者仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇佣与被雇佣或特性授权与被授权关系。<br />
        11.3除双方另有约定外，您同意营客通因经营业务需要有权将本协议项下的权利义务就部分或全部进行转让，并采取合理途径提前通过法定程序以本协议约定的有效方式通知您。<br />
        11.3您因使用集市平台服务所产生及与集市平台服务有关的争议，由集市平台经营者与您协商解决。协商不成时，可向营客通所在地上海市杨浦区人民法院提起诉讼。<br />
        11.3本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。集市平台经营者未就您或其他人士的某项违约行为采取行动，并不表明集市平台经营者撤回就任何继后或类似的违约事件采取行动的权利。<br />
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAgreeVisible = false">取 消</el-button>
        <el-button type="primary" @click="right">同意</el-button>
      </span>
    </el-dialog>
    <el-dialog class="loginSubmitCheck" title="提示" :visible.sync="loginSubmitCheckVisible" width="70%">
      <p>尊敬的集市供应商:</p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;为了更好的服务集市供应商和下游商户，近期平台即将上线银行分账系统，此分账系统手续费为0.5%.因此自2023年8月10日起，在平台服务费用1%的基础上，加收0.5%的分账手续费，合计1.5%。平台服务费+分账手续费将在货款结算中直接予以扣除。
      </p>
      <p>感谢您的理解与支持。</p>
      <p class="textR">集市平台</p>
      <p class="textR">2023年8月10日</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loginSubmitCheckVisible = false">取 消</el-button>
        <el-button type="primary" @click="loginSubmit">同 意</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetTenantId,
  Authenticate,
  GetUserDetail,
  GetUserMenu, TenantGetTenantDetail,
  AddSupplierSettled,
  ViewProgress,
  MobileVerifyCode
} from "../api/api";
import router from "@/router";
import { filterAsyncRouter } from "@/router/index";

const Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loginStr: "立即登录",
      logining: false,
      loginForm: {
        account: "",
        checkPass: ""
      },
      checked: false,
      isAgree: false,
      isAgreeVisible: false,
      isRegister: true,
      viewProgress: false,
      codeOrCountdown: '发送验证码',
      registerData: {
        contactPhone: null,
        valideCode: null
      },
      loginSubmitCheckVisible: false
    };
  },
  created() {
    const data = window.localStorage.getItem("remember");
    if (data) {
      const wordData = JSON.parse(Base64.decode(data));
      this.loginForm.account = wordData.account;
      this.loginForm.checkPass = wordData.checkPass;
      this.checked = wordData.checked;
    }
  },
  methods: {
    codeFun(time) {
      let data = {
        mobile: this.registerData.contactPhone,
        codeType: 50
      }
      MobileVerifyCode(data).then(res => {
        if (res.data.success) {
          this.codeOrCountdown = '60s'
          let itme = time
          this.timer = setInterval(() => {
            if (itme > 0 && itme <= time) {
              this.codeOrCountdown = itme-- + 's'
            } else {
              this.codeOrCountdown = '发送验证码'
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.$message.error(res.data.message)
        }
      })

    },
    right() {
      this.isAgreeVisible = false
      this.isAgree = true
    },
    agree() {
      this.isAgreeVisible = true
      console.log('agree')
    },
    registerSubmit() {
      let el = document.getElementById('messageBox');
      if (!this.registerData.contactPhone) {
        el.style.display = "block";
        el.innerHTML = "请输入手机号！";
        return false;
      }
      if (!RegExp(/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/).test(this.registerData.contactPhone)) {
        el.style.display = "block";
        el.innerHTML = "请输入正确手机号！";
        return false;
      }
      if (!this.registerData.valideCode) {
        el.style.display = "block";
        el.innerHTML = "请输入验证码！";
        return false;
      }
      el.style.display = "none";
      el.innerHTML = "";
      if (this.viewProgress) {
        let data = {
          mobile: this.registerData.contactPhone,
          verifyCode: this.registerData.valideCode
        }
        ViewProgress(data).then(res => {
          if (res.data.success) {
            let progress = res.data.data.response.progress
            // window.open(`http://admin.ksaxshop.com/SupplierRegister/Progress?step=${progress}`, "_blank")
            this.$router.push(`/SupEnterH5/State?step=${progress}`)
            // let { href } = this.$router.resolve({ path: `/SupEnterH5/State?step=${progress}`, });
            // window.open(href, "_blank");
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        AddSupplierSettled(this.registerData).then(res => {
          if (res.data == 0) {
            this.$message.error('验证码不正确！')
          } else {
            // window.open(`http://admin.ksaxshop.com/SupplierRegister/Register/EnterpriseInfo?phone=${this.registerData.contactPhone}`, "_blank")
            this.$router.push(`/SupEnterH5/Step1?phone=${this.registerData.contactPhone}`)
            // let { href } = this.$router.resolve({ path: `/SupEnterH5/Step1?phone=${this.registerData.contactPhone}` });
            // window.open(href, "_blank");
          }
        })
      }
    },
    loginSubmitCheck() {
      console.log('submit')
      if (!this.isAgree) return this.$message.error('请勾选供应商入驻协议')
      // 登录之前清空token
      this.$store.commit("saveToken", null);
      window.localStorage.removeItem("Token");

      let el = document.getElementById('messageBox');
      if (this.loginForm.account == "") {
        el.style.display = "block";
        el.innerHTML = "请输入用户名！";
        return false;
      }
      if (this.loginForm.checkPass == "") {
        el.style.display = "block";
        el.innerHTML = "请输入密码！";
        return false;
      }
      el.style.display = "none";
      el.innerHTML = "";
      // this.loginSubmitCheckVisible = true
      this.loginSubmit()
    },
    loginSubmit() {
      // this.loginSubmitCheckVisible = false
      this.$store.commit("saveTenantId", null);
      let loginParams = {
        userNameOrEmailAddress: this.loginForm.account,
        password: this.loginForm.checkPass,
        rememberClient: this.checked
      };
      if (RegExp(/@/).test(this.loginForm.account)) {
        let index = this.loginForm.account.indexOf('@');
        let telantName = null;
        let userName = null;
        telantName = this.loginForm.account.substring(index + 1, this.loginForm.account.length);
        userName = this.loginForm.account.substring(0, index);
        this.logining = true;
        this.loginStr = "登录中...";
        let that = this;
        GetTenantId({ tenancyName: telantName }).then((res) => {
          that.logining = false;
          if (res.data.success) {
            if (res.data.result.tenantId == null) {
              that.loginStr = "重新登录";
              return this.$message.error('租户名不正确');

            }
            that.$store.commit("saveTenantId", res.data.result.tenantId);
            loginParams.userNameOrEmailAddress = userName;
            that.loginFun(loginParams);
          } else {
            that.$message.error(res.data.error.message);
            that.loginStr = "重新登录";
          }
        }).catch((res) => {
          that.$message({
            message: "认证失败",
            type: "error",
          });
          that.logining = false;
          that.loginStr = "重新登录";
        });
      } else {
        this.loginFun(loginParams);
      }
    },
    loginFun(loginParams) {
      let that = this;
      that.logining = true;
      Authenticate(loginParams).then((res) => {
        that.logining = false;
        if (!res.data.success) {
          this.$message.error(res.data.error.message);
          that.loginStr = "重新登录";
        } else {
          var token = res.data.result.accessToken;
          that.$store.commit("saveToken", token);
          var curTime = new Date();
          var expiredate = new Date(
            curTime.setSeconds(
              curTime.getSeconds() + res.data.result.expireInSeconds
            )
          );
          that.$store.commit("saveTokenExpire", expiredate);
          window.localStorage.refreshtime = expiredate;
          window.localStorage.expires_in = res.data.result.expireInSeconds;
          that.getUserDetail(res.data.result.userId, token);
          // 租主 不调用 此接口
          // 租户 调用此接口
          // 根据 telentId 调接口  租主无 telentId
          if (this.$store.state.tenantId) {
            that.getTalentInfo();
          }

        }
      })
    },
    // 获取租户详情的 公司名称  用于登录后左上角的展示
    getTalentInfo() {
      // console.log('tenantId', this.$store.state.tenantId)
      let id = this.$store.state.tenantId;
      TenantGetTenantDetail({ Id: id }).then((res) => {
        // console.log('租户详情', res);
        if (res.data.success) {
          this.$store.commit('setTalentName', res.data.result)
        } else {
          this.$message.error(res.data.error.message || '获取租户详情失败, 请重试');
        }
      });
    },
    getUserDetail(userId, token) {
      let that = this;
      that.logining = true;
      GetUserDetail({ Id: userId }).then((res) => {
        that.logining = false;
        if (res.data.success) {
          // console.log('data**********', res.data.result)
          window.localStorage.user = JSON.stringify(res.data.result);
          that.$store.commit('setIsSignIn1', res.data.result)
          that.getMenuList(token);
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    getMenuList(token) {
      var that = this;
      that.logining = true;
      GetUserMenu().then((res) => {
        that.logining = false;
        if (!res.data.success) {
          that.$message({
            message: res.data.error.message,
            type: "error",
          });
        } else {
          let items = res.data.result.items;
          that.GetNavigationBar(items);
          that.$store.commit('setIsSignIn', true)
        }
      });
    },
    // 获取路由树
    GetNavigationBar(items) {
      var _this = this;
      let getRouter = items; //后台拿到路由
      if (getRouter.length > 0) {
        getRouter = filterAsyncRouter(getRouter); //过滤路由
        window.localStorage.router = JSON.stringify(getRouter);
        router.$addRoutes(getRouter); //动态添加路由
      }
      _this.$router.replace(
        _this.$route.query.redirect ? _this.$route.query.redirect : "/"
      );
      if (_this.checked) {
        let data = {
          account: _this.loginForm.account,
          checkPass: _this.loginForm.checkPass,
          checked: _this.checked,
        };
        localStorage.setItem(
          "remember",
          Base64.encode(JSON.stringify(data))
        );
      } else {
        localStorage.removeItem("remember");
      }
    },
    logoNow() {
      this.viewProgress = false
      // this.isRegister = false
      this.$router.push('/login')
    },
    registerFun() {
      this.isRegister = true
      this.viewProgress = false
      // window.open("http://admin.ksaxshop.com/SupplierRegister/Index", "_blank")
    }
  },
};
</script>
<style scoped>
.bg-wrap /deep/ .el-input__inner {
  /*width: 270px;*/
  /*height: 23px;*/
  /*line-height: 23px;*/
  /*border: 0;*/
  /*outline: 0;*/
  /*padding: 0;*/
  /*color: #595961;*/
  /*font-size: 13px;*/
  /*background-color: transparent;*/
  /*width: 472px;*/
  border: none;
  height: 62px;
  width: 100%;
  height: 62px;
  line-height: 62px;
  background: #F7F8FA;
}

.bg-wrap /deep/ .el-input__inner::placeholder {
  /*padding-left: 0;*/
  /*color: #b6b7bf;*/
  /*font-size: 12px;*/
  /*width: 136px;*/
  height: 62px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #BBBBBB;
  line-height: 62px;
}
</style>
<style scoped>
.table2 table,
table tr th,
table tr td {
  text-align: center;
  border: 1px solid #ccc;
}

.table2 table {
  width: 600px;
  border-collapse: collapse;
}

.table1 table,
table tr th,
table tr td {
  text-align: center;
  border: 1px solid #ccc;
}

.table1 table {
  width: 600px;
  border-collapse: collapse;
}

.table3 table,
table tr th,
table tr td {
  text-align: center;
  border: 1px solid #ccc;
}

.table3 table {
  width: 100%;
  border-collapse: collapse;
}

/* * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
} */

.bg-wrap {
  /* position: relative; */
  /* background: #E9F2FB; */
  padding: 30% 10px 0;
  /* display: flex; */
  /* background: url(../assets/img/login_bg.png) top left no-repeat; */
  /* background-size: 100% 100%; */
  /*background-size: cover;
  /*flex-direction: column;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  /*padding-bottom: 30px;*/
  /*min-height: 100vh;*/
  /*background: url(../assets/img/login_bg.png) top left no-repeat;*/
  /*background-size: cover;*/
  /*font-family: "Microsoft YaHei","微软雅黑",Arial,sans-serif;*/
}

.bg-wrap img {
  border: 0;
  -ms-interpolation-mode: bicubic;
  vertical-align: middle;
}

.main-cont-wrap {
  padding: 28px 0;
  background: #E9F2FB;
  width: 100%;
  border-radius: 12px;
}

.title {
  font-size: 21px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1E2E3F;
  border-bottom: 1px solid #D5DBE5;
  padding-bottom: 20px;
  padding-left: 30px;
}

.input-box {
  background: #F7F8FA;
  /* width: 500px; */
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #F7F8FA;
}

.ui-form-txt {
  /*display: inline-block;*/
  /*width: 70px;*/
  /*color: #595961;*/
  /*font-size: 13px;*/
}

.ui-form-item {
  position: relative;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #e3e3e3;
  box-sizing: border-box;
}

.ui-form-btn {
  margin-top: 40px;
  margin-bottom: 40px;
}

.ui-button {
  display: block;
  width: 270px;
  height: 40px;
  text-align: center;
  color: #fff;
  background: #2589ff;
  border-radius: 6px;
  font-size: 16px;
  border: 0;
  outline: 0;
}

.pdl28 {
  padding-left: 28px;
}

.pdr28 {
  padding-right: 28px;
}

.pdr15 {
  padding-right: 15px;
}

.flex-wrap {
  display: flex;
}

.flex-sb {
  justify-content: space-between;
}

.sub {
  flex: 1;
}

.g-mr20 {
  margin-right: 20px;
}

.g-ml10 {
  margin-left: 10px;
}

.g-mb10 {
  margin-bottom: 10px;
}

.g-mb20 {
  margin-bottom: 20px;
}

.g-mb25 {
  margin-bottom: 25px;
}

.g-mb30 {
  margin-bottom: 30px;
}

.g-mb40 {
  margin-bottom: 40px;
}

.s-fs16 {
  font-size: 16px;
}

.s-fs20 {
  font-size: 20px;
}

.cl0 {
  color: #000;
}

.s-fc-1f {
  color: #1f2026;
}

.s-fwb-600 {
  font-weight: 600;
}

.s-fwb-700 {
  font-weight: 700;
}

.pointer {
  cursor: pointer;
}

.msg-box {
  width: 270px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.msg-box .text {
  color: #ff5050;
  font-size: 12px;
  display: none;
}

.tool-box {
  width: 472px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.tool-box .register {
  display: flex;
  align-items: flex-end;
  cursor: pointer;

  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3B70FA;
}

.tool-box .remember {
  width: 64px;
  height: 16px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  line-height: 16px;
}

/* 覆盖谷歌浏览器自动填充登录输入框样式 */
/* Change the white to any color*/
/*input:-webkit-autofill,*/
/*input:-webkit-autofill:hover,*/
/*input:-webkit-autofill:focus,*/
/*input:-webkit-autofill:active {*/
/*  -webkit-box-shadow: 0 0 0 30px #f7f8fc inset !important;*/
/*}*/

/*Change text in autofill textbox*/
/*input:-webkit-autofill {*/
/*  -webkit-text-fill-color: #595961 !important;*/
/*}*/

.content-az {
  padding: 0 !important;
  border: none !important;
  overflow-y: hidden !important;
}

.left {
  height: 100vh;
  width: 50%;
}

.inner {
  /*display:flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

.input_style {
  /*width: 472px;*/
  /*height: 62px;*/
  /*border-radius: 10px;*/
  /*border: 1px solid #D5DBE5;*/
}

.subTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  margin-bottom: 16px;
}

.mb-16 {
  margin-bottom: 16px;
}

.mt_16 {
  margin-top: 16px;
}

.bd-b {
  border-bottom: 1px solid #D5DBE5;
}

.mrb20 {
  margin-bottom: 20px;
}

.bigTitle {
  display: inline-block;
  width: 256px;
  height: 32px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #191919;
  line-height: 32px;
  margin-bottom: 20px;
}

.el-icon-view {
  margin-right: 60px;
}

.ui-form-btn span {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}

.scrolling ::-webkit-scrollbar {
  width: 4px;
}

.scrolling ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.scrolling ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.setAStyle a {
  text-decoration: none;
}

.setAStyle a:hover,
a:visited,
a:link,
a:active {
  color: #333;
}

.textR {
  text-align: right;
}

.loginSubmitCheck>>>p {
  margin-top: 10px;
}
</style>
